"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var primaryHeader_1 = __importDefault(require("./primaryHeader"));
var landingPageHeader_1 = __importDefault(require("./landingPageHeader"));
var mobileHeader_1 = __importDefault(require("./mobileHeader"));
var searchbar_1 = __importDefault(require("./searchbar"));
exports.default = (function () {
    primaryHeader_1.default();
    landingPageHeader_1.default();
    mobileHeader_1.default();
    searchbar_1.default();
});
